import { MessagingBackend } from "@whatslly/commons/messagingBackend";
import { ContentCommands, CONTENT_COMMANDS_PREFIX, ContentCommandsTypes } from "@whatslly/commons/contentCommands";

export const contentBackend = new MessagingBackend<ContentCommandsTypes>(ContentCommands, CONTENT_COMMANDS_PREFIX);
const handler = contentBackend.getHandler((event: MessageEvent) => ({ request: event.data, respond: event.source?.postMessage }));
window.addEventListener("message", handler);
